module.exports = __webpack_public_path__ + "img/ic_box.e7411f9e.svg";